import { onDocumentReady } from '../utils/dom';
import './styles/index.scss'
import initBgVideo from './story-video';
import initVideoGallery from './story-video_2';
import initSubNav from './subnav';
import initAnimation from './story-section'

onDocumentReady(() => (
  initBgVideo(),
  initVideoGallery(),
  initSubNav(),
  initAnimation()
))